export default {
  headerWrapper: 'sticky top-0 pt-[40px] pb-[12px] bg-color-white z-10 px-[18px]',
  headerWrapperBackground: 'z-0',

  iconWrapper: 'sm:w-[590px] w-full flex items-center sm:justify-between',
  closeModalIcon: 'bg-[#E7E8EA] flex items-center justify-center h-[40px] w-[40px] rounded-full cursor-pointer',
  rightContent: 'flex items-center gap-5 ml-auto mr-[18px]',
  exportDropdown: 'font-inter',

  updateMessageContainer: 'bg-[#F0F3F6] flex items-flex-start justify-between gap-[16px] px-[16px] py-[12px] mt-[16px] mb-[8px] rounded-lg',
  updateMessage: 'w-3/4',
  updateButton: 'max-w-fit',
  versionTabsContainer: 'bg-color-white flex items-center pb-[12px] gap-5 pt-[8px] mt-[16px] overflow-x-auto w-full border-b-[1px] border-[#B6CBE3]',

  loader: 'border-[#EC6D25] mt-[24px]',
  entryWrapper: 'bg-color-white px-[18px] pb-[20px]',
  header: 'flex items-center justify-between mt-[24px]',
  headerTitle: 'font-interSemibold text-[24px] break-words max-w-[80%]',

  status: 'max-w-fit px-[12px] py-[4px] rounded-full uppercase font-interSemibold text-[14px]',
  pending: 'bg-[#FFF3E2] text-[#F79009]',
  rejected: 'bg-[#FFEFEE] text-[#F04438]',
  approved: 'bg-[#E7F5EF] text-[#12B76A]',

  date: 'font-inter text-[16px] text-[#585D69]',
  categoryWrapper: 'flex items-center gap-[10px]',
  categoryImg: 'h-[60px]',
  categoryTitle: 'font-interMedium text-[16px] leading-[19.36px]',
  photosWrapper: 'flex gap-[12px] overflow-x-auto max-w-[calc(100vw-40px)] overflow-x-auto',
  photo: 'h-[143px] min-w-[187px] rounded-lg object-cover',
  text: 'ml-[8px]',

  wrapper: 'flex items-center justify-center h-[56px] w-[67px] bg-color-white border border-[#B3CBDC] rounded-lg',
  info: 'font-inter text-[16px] text-color-text leading-[24px] ml-[8px] break-words',
  mapWrapper: 'h-[229px] mt-[8px] mb-[32px] rounded-lg z-0',

  buttons: 'flex justify-center gap-[16px] mb-[52px] px-[18px] mt-auto',
  acceptBtn: 'w-[100%] max-w-[300px]',
  declineBtn: 'w-[100%] bg-[#E7E8EA] max-w-[300px]',
  declineBtnText: 'text-[#F04438]',

  emptyMessage: 'mt-[24px] px-[18px]',

  titleWrapper: 'h-[32px] mt-[32px] mb-[12px] flex items-center bg-[#E6EEF3] px-[10px] rounded',
  titleText: 'font-inter text-[14px] text-[#585D69] uppercase',
  feelWrapper: 'flex items-center justify-center h-[56px] w-[67px] bg-[#F0F3F6] border border-[#B3CBDC] rounded-lg',
  feel: 'text-[24px]',
};
